module.exports = __webpack_public_path__ + "media/images/icon-SecureAuthorization-a1bc38ec.png";